import React, { createContext, useState, useEffect, useContext } from "react";
import { useMsal } from '@azure/msal-react';
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { isTestEnv } from "../globals";
import { useUser } from "./UserContext";

const TransactionsTypeContext = createContext();

export const TransactionsTypeProvider = ({ children }) => {
  const { accounts } = useMsal();
  const { user, loading: userLoading } = useUser();
  const [transactionsType, setTransactionsType] = useState({});
  const [loading, setLoading] = useState(true);
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  useEffect(() => {
    const hasPermission = user?.accessRights?.ObligoExceptionPage || user?.accessRights?.ViewObligoData;

    const fetchTransactionsType = async () => {
      try {
        const transactionsTypeResponse = await execute(
          "GET",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/financialData/transactionsType`
        );
        const transactionsType = await transactionsTypeResponse.value;
        setTransactionsType(transactionsType);
      } catch (error) {
        isTestEnv && console.error("Failed to fetch transactionsType", error);
      } finally {
        setLoading(false);
      }
    };

    if (accounts.length === 0 || (accounts.length > 0 && !userLoading && !hasPermission)) {
      setLoading(false);
    } else if (accounts.length > 0 && !userLoading && hasPermission) {
      fetchTransactionsType();
    }
    // if userLoading is still true, wait for the next render
  }, [accounts.length, execute, userLoading, user?.accessRights?.ObligoExceptionPage, user?.accessRights?.ViewObligoData]);

  return (
    <TransactionsTypeContext.Provider value={{ transactionsType, setTransactionsType, loading }}>
      {children}
    </TransactionsTypeContext.Provider>
  );
};

export const useTransactionsType = () => useContext(TransactionsTypeContext);